// extracted by mini-css-extract-plugin
module.exports = {"root":"ErrorInterstitial_root__kk79x","message":"ErrorInterstitial_message__Ce2Qb"};